import $ from 'jquery';
import SwipeAndPaging from 'ui/swipeNpaging.js';
import ImageSlider from 'ui/imageSlider.js';
import ShareModal from 'ui/share/modal.js';
import ManageFavorites from 'lib/favorite';
import 'ui/share/widget-share';

import 'theme/moydom/less/pages/post.less';
import 'theme/moydom/less/blocks/news.less';

$(() => {
    const $postContent = $('#post-content');
    const postInfo = window.postInfo || {};
    const images = postInfo.images || [];
    const imageSlider = new ImageSlider({
        static: true,
    });
    const manageFavorites = new ManageFavorites({
        el: 'body',
        btnSelector: '.js-toggleToFavoriteBtn',
        counterBoxSelector: '.js-favoriteCount',
        activeClass: 'op-share-counters-like-active',
        url: '/city/news/ajaxToggleToFavorite',
    });

    manageFavorites.init();

    // Init popular swipes
    $('.js-popular-news-block').each((i, e) => {
        var popularBlock = new SwipeAndPaging();

        popularBlock.run($(e));
    });

    if (images.length) {
        images.forEach((image) => {
            imageSlider.add(image);
        });

        $postContent
            .find('img')
            .parent()
            .each((idx, el) => {
                $(el).on('click', () => {
                    imageSlider.setIndex(idx).show();
                });
            });
    }

    $postContent
        .on('click', '.js-social-share', (e) => {
            const target = e.target;

            if (!target) {
                return;
            }

            //socialShare.share(undefined, target.getAttribute('data-social'));
        })
        .on('click', '.js-share', () => {
            const shareModal = new ShareModal();

            shareModal.show();
        });
});
